<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf=" (mode !== 'view' && mode !== 'view2') || mode=='mode'">
 
  <div class="row border-all-1px margin-left-0px">

    <div class="col-md-4 background-color margin-top-0px padding-left-9px" *ngIf="fieldx ">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color font-size-14"> {{fieldx.Title}} </label>
    </div>
    <div class="col-md-8 background-color margin-top-0px padding-right-9px">
      <button type="button" (click)="Add()"
              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right margin-top-5px margin-right-10px" id="FileUpload"
              name="upload " title="Click Here To Add New Row">
        <i class="fas fa-plus font-size-11 padding-bottom-3px"></i>
      </button>
    </div>
      
       
   
    
   
    <div class="row width-35pe " *ngIf="fieldx && fieldx.Columns">


      <div class="col-md-12">
        <div class="table-component margin-bottom-0px">
          <div class="table-responsive">
            <table class="table table-striped margin-left-zero overflow-x-scroll overflow-y-hidden">
              <thead class="">
                <tr>
                 
                  <th class="min-width-57px padding-top-5px padding-bottom-5px"></th>
                  <th class="min-width-10px font-size-11px padding-top-5px padding-bottom-5px">Slno</th>
                  <th *ngFor="let r of fieldx.Columns" class="padding-top-5px padding-bottom-5px font-size-11px">{{r.Title}}</th>


                </tr>
              </thead>
              <tbody class="table-body">
                <tr *ngFor="let row of fieldx.Rows; let RowIndex = index">
                  <td class="padding-top-5px padding-bottom-5px padding-right-0px">
                    <a (click)="edit_row(row)" class="font-size-13px color-Assign test-icons" title="Edit"><i class="fas fa-pencil-alt   nav-link-hand"></i></a>
                    <a class="nav-link-hand font-size-16px margin-left-15px test-icons padding-top-10px" title="Remove"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                    <!--<a (click)="edit_row(row)" class="nav-link-hand education-navlink" title="edit">
    <span class="badge"><i class="fas fa-pencil-alt"></i></span>
  </a>-->
                  </td>
                 
                  <td class="padding-top-0px padding-bottom-0px">{{RowIndex+1}}</td>
                  <td *ngFor="let c of row.Cells" class="padding-top-5px padding-bottom-5px">
                    <label class="margin-bottom-0px" *ngIf="c.ValueType!='Date'">{{c.Value}}</label>
                    <label class="margin-bottom-0px" *ngIf="c.ValueType=='Date'">{{c.Value | date:'MMM-dd-yyyy'}}</label>
                  </td>


                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>


  </div>

   


    </div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px border-all-form" *ngIf="mode=='view'">
  <div class="row  row-for-levels" *ngIf="fieldx ">
    <div class="col-md-4 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color font-size-18px"> {{fieldx.Title}} </label>
    </div>
    </div>
    <div class="row ">


      <div class="row width-35pe " *ngIf="fieldx && fieldx.Columns">


        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive">
              <table class="table table-striped margin-left-zero overflow-x-scroll overflow-y-hidden">
                <thead class="">
                  <tr>
                    <th class="min-width-10px padding-top-5px padding-bottom-5px font-size-11px">Slno</th>
                    <th *ngFor="let r of fieldx.Columns" class="padding-top-5px padding-bottom-5px font-size-11px">{{r.Title}}</th>
                    <!--<th></th>
                    <th></th>-->

                  </tr>
                </thead>
                <tbody class="table-body">
                  <tr *ngFor="let row of fieldx.Rows; let RowIndex = index">
                    <td class="padding-top-0px padding-bottom-0px">{{RowIndex+1}}</td>
                    <td *ngFor="let c of row.Cells" class="padding-top-5px padding-bottom-5px">
                      <label class="margin-bottom-0px" *ngIf="c.ValueType!='Date'">{{c.Value}}</label>
                      <label class="margin-bottom-0px" *ngIf="c.ValueType=='Date'">{{c.Value | date:'MMM-dd-yyyy'}}</label>

                    </td>
                    <!--<td>

                      <a (click)="edit_row(row)" class="nav-link-hand education-navlink" title="edit">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                    </td>
                    <td>
                      <a class="nav-link-hand education-navlink" title="Remove">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                    </td>-->

                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>


    </div>


  </div>




</div>
<div class="form-group col-md-12 col-xs-12 margin-bottom-5px" *ngIf="mode=='print'">
  <div class="row  row-for-levels" *ngIf="fieldx ">
    <div class="col-md-4 text-align-left label-padding-left-10px">
      <label for="firstName" class="margin-bottom-0px margin-top-5px label-color font-size-18px"> {{fieldx.Title}} </label>
    </div>
  </div>
  <div class="row ">


    <div class="row width-35pe " *ngIf="fieldx && fieldx.Columns">


      <div class="col-md-12">
        <div class="table-component">
          <div class="table-responsive">
            <table class="table table-striped margin-left-zero overflow-x-scroll overflow-y-hidden">
              <thead class="">
                <tr>
                  <!--<th class="min-width-10px padding-top-5px padding-bottom-5px font-size-11px">Slno</th>-->
                  <th *ngFor="let r of fieldx.Columns" class="padding-top-5px padding-bottom-5px font-size-11px">{{r.Title}}</th>
                  <!--<th></th>
                  <th></th>-->

                </tr>
              </thead>
              <tbody class="table-body">
                <tr *ngFor="let row of fieldx.Rows; let RowIndex = index">
                  <td class="padding-top-0px padding-bottom-0px">{{RowIndex+1}}</td>
                  <td *ngFor="let c of row.Cells" class="padding-top-5px padding-bottom-5px">
                    {{c.Value}}
                  </td>
                  <!--<td>

                    <a (click)="edit_row(row)" class="nav-link-hand education-navlink" title="edit">
                      <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                    </a>
                  </td>
                  <td>
                    <a class="nav-link-hand education-navlink" title="Remove">
                      <span class="badge">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </td>-->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>


    </div>


  </div>




</div>
<div class="col-md-12 padding-left-0px padding-right-0px" *ngIf="mode=='view2'">
  <div class="row margin-left-0px margin-right-0px" *ngIf="fieldx ">
    <div class="col-md-10 padding-left-0px padding-right-0px text-align-left">
      <label class="margin-bottom-1px margin-left-10px font-size-14">{{fieldx.Title}}</label>
    </div>
  </div>
  <div class="row margin-left-0px margin-right-0px" *ngIf="fieldx && fieldx.Columns">
    <div class="col-md-12 padding-left-0px padding-right-0px">
      <div class="row margin-left-0px margin-right-0px" *ngFor="let row of fieldx.Rows; let RowIndex = index">
        <div class="col-md-1 padding-left-0px padding-right-0px">
          <label class="margin-bottom-0px font-size-14">[ {{RowIndex+1}} ]</label>
        </div>
        <div class="col-md-11 padding-left-0px padding-right-0px">
          <div *ngFor="let c of row.Cells;let CellIndex = index" class=" row margin-left-0px margin-right-0px">
            <div class="col-md-6 padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px font-size-14" *ngIf="fieldx.Columns[CellIndex]">{{fieldx.Columns[CellIndex].Title}}</label>
            </div>
            <!--getCellTitle(CellIndex)-->

            <div class="col-md-6 padding-left-0px padding-right-0px">
              <label class="margin-bottom-0px font-size-14" *ngIf="c.ValueType!='Date'">{{c.Value}}</label>
              <label class="margin-bottom-0px font-size-14" *ngIf="c.ValueType=='Date'">{{c.Value | date:'MMM-dd-yyyy'}}</label>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>


</div>
